// extracted by mini-css-extract-plugin
module.exports = {"locationBreadcrumbs":"BreadCrumbs_locationBreadcrumbs__E1bOi"};